import React, { Fragment } from "react";

// core components
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  Zoom,
  Fab,
  useScrollTrigger,
  CssBaseline,
  Grid,
  Toolbar,
  AppBar,
} from "@mui/material";

import logo from "assets/img/logoPalanka.png";

import { headerStyle } from "assets/jss/material-dashboard-react/components/headerStyle.js";

const useStyles = makeStyles(headerStyle);

function ScrollTop(props) {
  const { children, window } = props;
  const classes = useStyles();
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  return (
    <Zoom in={trigger}>
      <div
        onClick={handleClick}
        role="presentation"
        className={classes.rootScrollTop}
      >
        {children}
      </div>
    </Zoom>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default function HeaderLogin(props) {
  const classes = useStyles();

  return (
    <Fragment>
      <CssBaseline />
      <AppBar className={classes.appBarPage}>
        <Toolbar>
          <Grid container>
            <Grid item xs={12} md={3}>
              <img
                src={logo}
                alt="validate"
                style={{
                  width: 120,
                  marginLeft: 30,
                  objectFit: "contain",
                }}
              />
            </Grid>
            <Grid item xs={12} md={9}>
              <span className={classes.subtextCard}>
                PLATAFORMA DE ADMINISTRACIÓN DE PRUEBAS TÉCNICAS
              </span>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <Toolbar id="back-to-top-anchor" />
      <ScrollTop {...props}>
        <Fab
          className={classes.scrollTop}
          size="small"
          aria-label="scroll back to top"
        >
          <KeyboardArrowUpIcon />
        </Fab>
      </ScrollTop>
    </Fragment>
  );
}
